"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";

const DelayedTrackingScripts = dynamic(() => import("./DelayedTrackingScripts"), { ssr: false });

export default function DelayedTracking() {
  const pathname = usePathname();
  return pathname.startsWith("/csat/") ? null : <DelayedTrackingScripts />;
}
